module.exports = __webpack_public_path__ + "media/images/expert__petter-northug-e1841c33a82740b2bab8c33e681b0d1e.png";